import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleOrder,
  getSaleOrderById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getSaleOrderAdditionalChargeList,
  createSaleOrder,
  convertToSaleInvoice,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleOrders: [],
  edit: false,
  saleOrder: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleOrder: false,
  loadingNext: false,
  saveAndContinue: false,
  saleOrderDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
    },
  ],
  additionalCharges: null,
  showCreateModal: false, // ✅ Add this
};

export const saleOrderSlice = createSlice({
  name: "saleOrder",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    saleOrderDetailsUpdated: (state, action) => {
      const sam = action.payload?.reduce((acc, pos) => {
        return Number(pos.actualQuantity) + acc;
      }, 0);

      state.saleOrderDetails = action.payload;
      state.additionalCharges = state.additionalCharges.map((value) => {
        return { ...value, amount: value.canEdit ? value.rate * sam : value.amount };
      });
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    clearSaleOrderDetails: (state) => {
      state.saleOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
    },
    clearAllSaleOrder: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleOrder = false;
      state.saleOrder = null;
      state.saveAndContinue = false;
      state.saleOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
      state.additionalCharges = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSaleOrderAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getSaleOrderAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getSaleOrderAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });

    // getSaleOrderById
    builder.addCase(getSaleOrderById.pending, (state) => {
      state.loading = true;
      state.saleOrder = null;
    });
    builder.addCase(getSaleOrderById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleOrder = action.payload.data;
      state.saleOrderDetails = action.payload.data?.saleOrderDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCharges =
        action.payload.data?.salesOrderMainAdditionalChargeCost.length > 0
          ? action.payload.data?.salesOrderMainAdditionalChargeCost
          : null;
    });
    builder.addCase(getSaleOrderById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleOrder = null;
    });

    builder.addMatcher(
      isAnyOf(
        getSaleOrder.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleOrder = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleOrder.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleOrder = false;
        state.saleOrders = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleOrder.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleOrder = false;
      }
    );
    builder.addMatcher(isAnyOf(createSaleOrder.pending, convertToSaleInvoice.pending), (state) => {
      state.loadingCreate = true;
    });
    builder.addMatcher(isAnyOf(createSaleOrder.fulfilled, convertToSaleInvoice.fulfilled), (state, action) => {
      state.loadingCreate = false;
    });
    builder.addMatcher(isAnyOf(createSaleOrder.rejected, convertToSaleInvoice.rejected), (state) => {
      state.loadingCreate = false;
    });
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  saleOrderDetailsUpdated,
  updatedAdditionalCharges,
  clearSaleOrderDetails,
  clearAllSaleOrder,
} = saleOrderSlice.actions;

export default saleOrderSlice.reducer;
